import { render, staticRenderFns } from "./141.vue?vue&type=template&id=01d187a8&scoped=true&"
import script from "./141.vue?vue&type=script&lang=js&"
export * from "./141.vue?vue&type=script&lang=js&"
import style0 from "./141.vue?vue&type=style&index=0&id=01d187a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d187a8",
  null
  
)

export default component.exports